import { HighlightChart } from 'src/components/organisims/HighlightChart';
import {
  ChartWrap,
  Container,
  GoalBox,
  GoalCard,
  IconTextBox,
  ImgBox,
  IntroBox,
  PrevHeader
} from './styles';
import { BodyShape } from 'src/components/organisims/BodyShape';
import { RadarChart } from 'src/components/organisims/RadarChart';
import {
  PrevHeaderBarTemplate,
  PrevHeaderBarWithTitleTemplate
} from '#templates';
import { PATH } from '#const/path';
import profile from '#assets/img/coach_profile1.jpg';
import { BoxIcon, Text } from '#atoms';
import { useNavigate } from 'react-router';
import { useEffect, useState } from 'react';
import Icon from '#assets/svg/bar_Chart.svg';
import bodyIcon from '#assets/svg/Flexed biceps.svg';
import { UserInfoBox } from '#pages/PortfolioLoad/styles';
import styled from 'styled-components';
export const HighlightHome = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const navigate = useNavigate();
  const handleScroll = () => {
    setScrollPosition(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <Container>
      <PrevHeader onClick={() => navigate(-1)} scroll={scrollPosition}>
        <BoxIcon
          type="prev-arrow"
          boxColor="transparent"
          size={18}
          //   onlyIcon
        ></BoxIcon>
      </PrevHeader>
      <ImgBox>
        <img src={profile} />
      </ImgBox>
      <IntroBox>
        <Text textStyle="t1" style={{ lineHeight: '3rem' }}>
          20대 마지막을 <br />
          바디프로필 촬영으로 마무리하다
        </Text>
        <Text
          style={{
            fontSize: '1.6rem;',
            lineHeight: '2.1rem',
            color: '#8e899f'
          }}
        >
          노을 트레이너와 함께한 최**회원님의 이야기
        </Text>
        <GoalBox>
          <GoalCard>
            <Text>목표</Text>
            <IconTextBox>
              <img src={bodyIcon} width={18} height={18} />
              <Text>바디프로필</Text>
            </IconTextBox>
          </GoalCard>
          <GoalCard>
            <Text>기간</Text>
            <Text>8주</Text>
          </GoalCard>
          <GoalCard>
            <Text>횟수</Text>
            <Text>16회</Text>
          </GoalCard>
        </GoalBox>
        <UserInfoBox>
          <div>
            <span>회원 정보</span>
            <p>29세 · 남성</p>
          </div>
          <div>
            <span>수업 기간</span>
            <p>2023.11.20 ~ 2023.12.19</p>
          </div>
        </UserInfoBox>
        <InputArea>
          <InputLabel>소개글</InputLabel>
          <TextArea>
            {`안녕하세요 노을 트레이너입니다.
이 회원님은 체지방률이 과다한 과체중 비만형의 체형으로 지방 연소와 근육 증가를 중심으로 트레이닝을 진행했습니다.

식단 관리에 어려움이 있으셔서 제가 매일 식단 인증을 요구드렸고, 피드백을 주고받으며 최적의 식단을 찾아갔습니다.

회원님도 저를 믿고 잘 따라 주셨고, 그 결과 다이어트 성공과 더불어 바디프로필까지 촬영할 수 있었습니다.`}
          </TextArea>
        </InputArea>
      </IntroBox>

      <ChartWrap>
        <HighlightChart />
        <BodyShape />
        <RadarChart data={data} labels={labels} />
      </ChartWrap>
    </Container>
  );
};
const data = [55, 40, 35, 20, 10, 45, 20, 40];
const labels = ['등', '가슴', '어깨', '이두', '삼두', '코어', '하체', '유산소'];

export const InputArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  position: relative;
`;

export const InputLabel = styled.label`
  color: white;
`;

export const TextArea = styled.div`
  background-color: #18171c;
  padding: 1.6rem;
  border: 0.1rem solid #4d495a;
  border-radius: 0.8rem;
  color: #c9c7d1;
  white-space: pre-line;
`;
